'use client';
import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { levels } from '@/lib/mockData';
import type { Language } from '@/lib/i18n';

interface Props {
  levels?: typeof import('@/lib/mockData').levels;
  language: Language;
}

function CustomTooltip({ active, payload, label }: { active?: boolean; payload?: { value: number }[]; label?: string }) {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-border rounded-xl px-3 py-2 shadow-lg">
        <p className="text-xs text-muted-foreground mb-0.5">{label}</p>
        <p className="text-sm font-700 text-primary">{payload[0].value}%</p>
      </div>
    );
  }
  return null;
}

export default function AdminStatsChart({ levels: levelsData, language }: Props) {
  const data = (levelsData ?? levels).map((l) => ({
    name: `N${l.number}`,
    completion: l.completionPercent,
    color: l.color,
  }));

  return (
    <div className="bg-card rounded-2xl border border-border card-shadow p-5">
      <h3 className="text-base font-600 text-foreground mb-4">
        {language === 'fr' ? 'Complétion par niveau' : 'Завершение по уровням'}
      </h3>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
          <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
            domain={[0, 100]}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="completion" fill="var(--primary)" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}